// constants.js
// export const BASE_URL = "http://internaltesting.fourmodules.com:3005/bossisalwaysright/reactproject";
export const BASE_URL = "https://jobcritics.com";
// export const JS_PATHS = {
//     MAIN_JS: `${BASE_URL}/assets/js/main.js`,
// };

export const IMAGE_PATHS = {
                ///// HOMEPAGE & TAKE TEST //////////
    LOGO: `${BASE_URL}/assets/img/logoFav/biar_logo.webp`,
    FIRSTBG: `${BASE_URL}/assets/img/biar/firstBg.webp`,
    SECONDBG: `${BASE_URL}/assets/img/biar/BKGRND2.webp`,
    FIRST: `${BASE_URL}/assets/img/biar/1.webp`,
    SECOND: `${BASE_URL}/assets/img/biar/2.webp`,
    THRID: `${BASE_URL}/assets/img/biar/3.webp`,
    FOURTH: `${BASE_URL}/assets/img/biar/4.webp`,
    GOOGLE: `${BASE_URL}/assets/img/biar/google.webp`,
    IN: `${BASE_URL}/assets/img/biar/in.webp`,
    USER: `${BASE_URL}/assets/img/biar/user.webp`,
    BUILDING: `${BASE_URL}/assets/img/biar/building.webp`, 
    SCHOOL: `${BASE_URL}/assets/img/biar/school.webp`,       
    LOADER: `${BASE_URL}/assets/img/biar/loader.gif`, 
    WELCOME: `${BASE_URL}/assets/img/biar/welcome.jpg`,
    PROFILE: `${BASE_URL}/assets/img/biar/profile.webp`,
    EXPERIENCE: `${BASE_URL}/assets/img/biar/experience.webp`,
    EDUCATION: `${BASE_URL}/assets/img/biar/education.webp`,
    PHOTO: `${BASE_URL}/assets/img/biar/photo.webp`,
    LOGOWHITE: `${BASE_URL}/assets/img/logoFav/logoWhite.webp`,
    homecorporateimg05: `${BASE_URL}/assets/img/biar/home-corporate-img-05.webp`,
    homefinancerequestacallbg: `${BASE_URL}/assets/img/biar/form.webp`,
    contactusclassicbg1: `${BASE_URL}/assets/img/biar/contact.webp`,
    homestartupbusinessprocess: `${BASE_URL}/assets/img/biar/home-startup-business-process.webp?v1`,
    homedigitalagencyimg01: `${BASE_URL}/assets/img/biar/home-digital-agency-img-01.webp`,
    homebusinessservicesimg02: `${BASE_URL}/assets/img/biar/home-business-services-img02.webp`,
    ourstoryimg11: `${BASE_URL}/assets/img/biar/our-story-img11.webp`,
    ourservices01: `${BASE_URL}/assets/img/biar/our-services-01.webp`,
    ourservices02: `${BASE_URL}/assets/img/biar/our-services-02.webp`,
    punchline: `${BASE_URL}/assets/img/biar/punchline.webp`,
    ourservices03: `${BASE_URL}/assets/img/biar/ourservices03.webp`,
    RateForm: `${BASE_URL}/assets/img/biar/rateForm.webp?v1`,
    WALLET: `${BASE_URL}/assets/img/biar/WALLET.webp?v1`,
    WelcomePopup: `${BASE_URL}/assets/img/biar/welcomePopup.webp?v1`,
        
};



export const base64Encode = (data) => {
    return btoa(data);
};

export const base64Decode = (data) => {
    return atob(data);
};
// ✅ Function to get "st", "nd", "rd", or "th" suffix
function getDaySuffix(day) {
    if (day > 3 && day < 21) return "th"; // Covers 4th to 20th
    switch (day % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
    }
}
export const formatDate  = (date)=> {
    const day = date.getDate();
    const suffix = getDaySuffix(day);
    const month = date.toLocaleString("en-GB", { month: "long" });
    const year = date.getFullYear();
    
    return `${day}${suffix} ${month} ${year}`;
}

export const formatExperienceDate = (start_month, start_year, end_month, end_year) => {
    const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    // Get current date if end date is null (present job)
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();

    // Convert month number to abbreviation
    const startMonthStr = months[start_month - 1];
    const endMonthStr = end_month ? months[end_month - 1] : null;

    // If still working, use "Present" only once
    const endYearStr = end_year ? end_year : (!end_month ? "Present" : "");

    // Calculate experience duration
    const startDate = new Date(start_year, start_month - 1);
    const endDate = end_year ? new Date(end_year, (end_month || 12) - 1) : currentDate;

    let totalMonths = (endDate.getFullYear() - startDate.getFullYear()) * 12 + (endDate.getMonth() - startDate.getMonth()) + 1;
    let years = Math.floor(totalMonths / 12);
    let monthsDiff = totalMonths % 12;

    // Format duration: show only months if years is 0
    let durationStr;
    if (years === 0) {
        durationStr = `${monthsDiff} ${monthsDiff === 1 ? 'month' : 'months'}`;
    } else {
        durationStr = `${years} ${years===1?'yr':'yrs'}  ${monthsDiff===0?'':monthsDiff} ${monthsDiff === 1 ? 'month' : (monthsDiff===0?'':'months')}`;
    }

    // Final formatted string with condition to handle "Present"
    return `${startMonthStr} ${start_year} - ${endMonthStr ? endMonthStr + ' ' : ''}${endYearStr} (${durationStr})`;
};

export const toCustomCamelCase = (string) => {
    // Replace underscores, hyphens, or spaces with spaces
    string = string.replace(/[_-\s]+/g, ' ');
    const words = string.trim().split(' ');
    
    // Process first word: capitalize first letter, lowercase rest
    const firstWord = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();
    let result = firstWord + ' ';
    
    // Process remaining words: capitalize first letter, lowercase rest
    for (let i = 1; i < words.length; i++) {
      result += words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase() + ' ';
    }
    
    return result.trim();
  };
  export const BASE_URL_A = "https://api.jobcritics.com";
  export const DOMAIN_URL = BASE_URL_A;
  export const API_BASE_URL = BASE_URL_A+"/api"; 
//   https://api.jobcritics.com
// http://internaltesting.fourmodules.com:3006

export function getPerformanceRating(score) {
    const ratings = {
      5: { level: 'Exceptional', description: 'A role model; consistently outstanding in all aspects.' },
      4: { level: 'Advanced', description: 'Performs beyond expectations with strong consistency.' },
      3: { level: 'Proficient', description: 'Reliable and meets expectations.' },
      2: { level: 'Developing', description: 'Making progress; building consistency.' },
      1: { level: 'Emerging', description: 'Just getting started; shows potential for growth.' }
    };
  
    // Return the rating object if the score exists, otherwise return null
    return ratings[score] || null;
  }
  export function getPerformanceRatingToolTipData(rating) {
    if (rating >= 4.5) return getPerformanceRating(5);
    if (rating >= 4.0 && rating < 4.5) return getPerformanceRating(4);
    if (rating >= 3.0 && rating < 4.0) return getPerformanceRating(3);
    if (rating >= 2.0 && rating < 3.0) return getPerformanceRating(2);
    if (rating >= 1.0 && rating < 2.0) return getPerformanceRating(1);
  
    // Return the rating object if the score exists, otherwise return null
    return { level: 'No Rating', description: '' } // rating < 2.0
  }
  
// export const JS_PATHS = {
